import React from 'react';



type Props = {
  className?: string;
}
export const PlusVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '24' height = '24' viewBox = '0 0 24 24' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '2' d = 'M12 1V23M23 12H1' />
    </svg>
  );
};
